import { connect } from 'react-redux';
import * as RX from 'reactxp';

import { applyBreakpoints } from '../../utils/breakpoints';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';

interface OutlineBoxProps {
  children: any;
  row?: boolean;
  window: { width: number, multiplier: number };
}

const styles = (multiplier) => ({
  outlineBox: RX.Styles.createViewStyle({
    backgroundColor: colors.white,
    borderColor: colors.lightGrey,
    borderWidth: 1 * multiplier,
    flexDirection: 'column',
    marginBottom: 12 * multiplier,
    overflow: 'visible',
    padding: (multiplier > 1 ) ? 0 * multiplier : 16 * multiplier,
    paddingBottom: 16 * multiplier,
    paddingLeft: (multiplier > 1) ? 8 * multiplier : 16 * multiplier,
  }),
});

export class OutlineBox extends RX.Component<OutlineBoxProps> {

  public render() {
    const { children, row, window: { width, multiplier } } = this.props;
    return (
      <RX.View style={[
        styles(multiplier).outlineBox,
        ...applyBreakpoints(width, { md: { flexDirection: row ? 'row' : 'column', justifyContent: 'space-between'}})
      ]}>
        {children}
      </RX.View>
    );
  }
};

export default connect(mapStateToProps)(OutlineBox);



// WEBPACK FOOTER //
// ./src/components/outline_box/index.tsx